

<mat-card class="knso-card project-setup-container">
    <mat-card-header *ngIf= "!loading">
        <div>
            <mat-toolbar class="layout-row">
                <div *ngIf="editProject.name == null">
                    <span class="projectText">{{editProject.name}}</span>
                </div>
                <div *ngIf="editProject._id == null">
                    <span>New Project</span>
                </div>
                <div *ngIf="editProject._id">
                    <span>Edit Project</span>
                </div>
                <button mat-icon-button (click)="closeDialog()"><mat-icon>close</mat-icon></button>
            </mat-toolbar>
            <div class="programName">
                Program: {{editProject.programName}}
            </div>
        </div>
    </mat-card-header>
    <form #editProjectForm="ngForm">
    <mat-card-content class="project-setup-content-container" *ngIf= "!loading" >
        <div class="section-header chevronAlign">
            <a class="account__details-collapse">
                <mat-icon class="collapse-icon" 
                    [ngClass]="{'collapse-icon--open' : generalInfoPanelOpenState}"
                    (click)="generalInfoPanelOpenState = !generalInfoPanelOpenState">chevron_right
                </mat-icon>
            </a>
            <div class="headerPadding">
                General Information
            </div>
        </div>
        <mat-expansion-panel [expanded]="generalInfoPanelOpenState" class="hidePanel">
            <div class="section-body layout-row layout-align-start-center">
                <mat-form-field class="projectName" appearance="outline">
                    <mat-label>Project Name</mat-label>
                    <input 
                    matInput 
                    ngModel 
                    [(ngModel)]="editProject.name" 
                    #projectName="ngModel" 
                    name="projectName"
                    id="projectName" 
                    type="text" 
                    aria-label="Project Name"
                    required>
                </mat-form-field>
            
                <mat-form-field class="programName" appearance="outline">
                    <mat-label>Program Name</mat-label>
                    <mat-select 
                        (selectionChange)="programSelected($event)"
                        [disabled] = "editMode == true"
                        name="programName" 
                        ngModel 
                        [(ngModel)]="editProject.programName" 
                        id="programName"
                        #programName="ngModel"
                        required
                        [compareWith]="compareValues"
                        aria-label="Program Name">
                        <mat-option *ngFor="let program of programs;" [value]="program.name">
                            <span>{{program.name}}</span>
                        </mat-option>
                        <mat-option [value]="null" id="none"> none </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="section-body layout-row layout-align-start-center">
                <mat-form-field class="projectCode" appearance="outline">
                    <mat-label>Project Code</mat-label>
                    <input matInput ngModel 
                    [(ngModel)]="editProject.projectCode" 
                    #projectCode="ngModel" 
                    name="projectCode"
                    id="projectCode" 
                    type="text" 
                    aria-label="Project Code"
                    required>
                </mat-form-field>
                <mat-form-field class="projectNumber" appearance="outline"
                *ngIf="selectedProject.programType !== 'Multifamily'">
                    <mat-label>IHA Project Number</mat-label>
                    <input matInput ngModel 
                    [(ngModel)]="editProject.projectNumber"
                    #projectNumber="ngModel" 
                    name="projectNumber"
                    id="projectNumber" 
                    type="text"
                    aria-label="Project Number">
                </mat-form-field>
                <mat-form-field class="tracsMailboxNumber" appearance="outline"
                *ngIf="tracsMailboxNumberFormGroup && selectedProject.programType === 'Multifamily'">
                    <mat-label>Mailbox Number</mat-label>
                    <input matInput ngModel 
                    [(ngModel)]="editProject.tracsMailboxNumber"
                    #mailboxNumber="ngModel" 
                    name="tracsMailboxNumber"
                    id="tracsMailboxNumber" 
                    type="text"
                    aria-label="Mailbox Number"
                    required>
                    <mat-error *ngIf="tracsMailboxNumberFormGroup.get('tracsMailboxNumber').errors?.required">
                        <div>Mailbox Number is required for Multifamily programs.</div>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="ampProject" appearance="outline" 
                *ngIf="displayAmpProject">
                    <mat-label>AMP Project Number</mat-label>
                    <input matInput
                    [formControl]="ampProjectFormGroup.get('ampProject')"    
                    name="ampProject"
                    id="ampProject" 
                    type="text"
                    aria-label="AMP Project Number"
                    (change)="onAmpProjectChange()">
                    <mat-error *ngIf="ampProjectFormGroup.get('ampProject').errors?.minlength">
                        <div>AMP Project Number needs exactly six digits. Ex. 000001</div>
                    </mat-error>
                    <mat-error *ngIf="ampProjectFormGroup.get('ampProject').errors?.maxlength">
                        <div>AMP Project Number needs exactly six digits. Ex. 000001</div>
                    </mat-error>
                    <mat-error *ngIf="ampProjectFormGroup.get('ampProject').errors?.pattern">
                        <div>AMP Project Number is restricted to numbers only</div>
                    </mat-error>
                </mat-form-field>
            </div>
        </mat-expansion-panel>
            <div class="section-header chevronAlign">
                <a class="account__details-collapse">
                    <mat-icon class="collapse-icon" 
                        [ngClass]="{'collapse-icon--open' : customAttributesInfoPanelOpenState}"
                        (click)="customAttributesInfoPanelOpenState = !customAttributesInfoPanelOpenState">chevron_right
                    </mat-icon>
                </a>
                <div class="headerPadding">
                    Custom Attributes
                </div>
            </div>
            <mat-expansion-panel [expanded]="customAttributesInfoPanelOpenState" class="hidePanel">
                <div class="section-body">
                    <app-custom-attributes
                        *ngIf="customAttributesTemplates?.length; else noCustomAttributes"
                        [entity]="'Project'" 
                        [editMode]="true" 
                        [(currentCustomAttributes)]="editProject.customAttributes" 
                        [sqlData]="true">
                    </app-custom-attributes>
                    <ng-template #noCustomAttributes>
                        <p>There are no custom attributes that apply to this project.</p>
                    </ng-template>
                </div>
            </mat-expansion-panel>
            <div class="section-header chevronAlign" *ngIf="program?.programType === 'Tax Credit'">
                <a class="account__details-collapse">
                    <mat-icon class="collapse-icon" 
                        [ngClass]="{'collapse-icon--open' : setAsideInfoPanelOpenState}"
                        (click)="setAsideInfoPanelOpenState = !setAsideInfoPanelOpenState">chevron_right
                    </mat-icon>
                </a>
                <div class="headerPadding">
                    Set-Aside Allocations
                </div>
            </div>
            <mat-expansion-panel [expanded]="setAsideInfoPanelOpenState" class="hidePanel" *ngIf="program?.programType === 'Tax Credit'">
                <div class="section-body">
                    <div class="section-body layout-row layout-align-start-center">
                        <mat-form-field class="unitsAt30" appearance="outline">
                            <mat-label>Units at 30%</mat-label>
                            <input matInput ngModel 
                            [(ngModel)]="editProject.taxCreditSetAsides.unitsAt30" 
                            #unitsAt30="ngModel" 
                            name="unitsAt30"
                            id="unitsAt30" 
                            type="number" 
                            aria-label="Units at 30%">
                        </mat-form-field>
                        <mat-form-field class="unitsAt60" appearance="outline">
                            <mat-label>Units at 60%</mat-label>
                            <input matInput ngModel 
                            [(ngModel)]="editProject.taxCreditSetAsides.unitsAt60" 
                            #unitsAt60="ngModel" 
                            name="unitsAt60"
                            id="unitsAt60" 
                            type="number"
                            aria-label="Units at 60%">
                        </mat-form-field>
                    </div>
                    <div class="section-body layout-row layout-align-start-center">
                        <mat-form-field class="unitsAt40" appearance="outline">
                            <mat-label>Units at 40%</mat-label>
                            <input matInput ngModel 
                            [(ngModel)]="editProject.taxCreditSetAsides.unitsAt40" 
                            #unitsAt40="ngModel" 
                            name="unitsAt40"
                            id="unitsAt40" 
                            type="number"
                            aria-label="Units at 40%">
                        </mat-form-field>
                        <mat-form-field class="unitsAtOther" appearance="outline">
                            <mat-label>Units at Other</mat-label>
                            <input matInput ngModel 
                            [(ngModel)]="editProject.taxCreditSetAsides.unitsAtOther" 
                            #unitsAtOther="ngModel" 
                            name="unitsAtOther"
                            id="unitsAtOther" 
                            type="number"
                            aria-label="Units at Other">
                        </mat-form-field>
                    </div>
                    <div class="section-body layout-row layout-align-start-center">
                        <mat-form-field class="unitsAt50" appearance="outline">
                            <mat-label>Units at 50%</mat-label>
                            <input matInput ngModel
                            [(ngModel)]="editProject.taxCreditSetAsides.unitsAt50"
                            #unitsAt50="ngModel"    
                            name="unitsAt50"
                            id="unitsAt50" 
                            type="number"
                            aria-label="Units at 50%">
                        </mat-form-field>
                    </div>
                </div>
            </mat-expansion-panel>
            <div *ngIf="selectedProject.programType !== 'Loan' && selectedProject.programType !== 'Misc'">
                <div class="section-header chevronAlign">
                    <a class="account__details-collapse">
                        <mat-icon class="collapse-icon" 
                            [ngClass]="{'collapse-icon--open' : monthlyChargeInfoPanelOpenState}"
                            (click)="monthlyChargeInfoPanelOpenState = !monthlyChargeInfoPanelOpenState">chevron_right
                        </mat-icon>
                    </a>
                    <div class="headerPadding">
                        Monthly Charge Calculation Information
                    </div>
                </div>
                <div *ngIf="!editProject.programName" class="project-left-padding">
                    Please select a program
                </div>
            
                <div *ngIf="editProject.programName">
                    <mat-expansion-panel [expanded]="monthlyChargeInfoPanelOpenState" class="hidePanel" *ngIf="program.programType !== 'Loan' && program.programType !== 'Misc'">
                        <app-project-rent-calc
                            [programType]="program.programType" 
                            [(rentcalc)]="editProject.rentCalc" 
                            [programRentCalc]="program.programSettings"
                            [housingAuthority]="housingAuthority"
                            (rentCalcChanged)= "overrideChanged($event)"
                        ></app-project-rent-calc>
                        <!--  [ngModel]="inputValue" (ngModelChange)="onChange($event)" -->
                    </mat-expansion-panel>
                </div>
            </div>

            <div class="section-header chevronAlign">
                <a class="account__details-collapse">
                    <mat-icon class="collapse-icon" 
                        [ngClass]="{'collapse-icon--open' : accountingInfoPanelOpenState}"
                        (click)="accountingInfoPanelOpenState =!accountingInfoPanelOpenState">chevron_right
                    </mat-icon>
                </a>
                <div class="headerPadding">
                    Accounting Information
                </div>
            </div>
            
            <mat-expansion-panel [expanded]="accountingInfoPanelOpenState" class="hidePanel"> 
                <div class="layout-row layout-align-start-center section-body">
                    <mat-form-field class="assistanceCalcKey" appearance="outline">
                        <mat-label>Select Tenant Account Definition</mat-label>
                        <mat-select ngModel
                            [(ngModel)]="editProject.chartOfAccounts" 
                            name="selectedChartOfAccounts"
                            placeholder="Select Subledger Mapping"
                            #selectedChartOfAccounts="ngModel"
                            >  
                            <mat-option *ngFor="let coa of chartOfAccounts" [value]="coa._id">
                                {{coa.name}}</mat-option>
                            <mat-option [value]="null" id="none"> none </mat-option>
                        </mat-select>  
                    </mat-form-field>
                </div>
                <div class="layout-row layout-align-start-center section-body"
                    *ngIf="selectedProject.programType != 'Loan'">
                    <mat-form-field class="sourceOfFunding" appearance="outline">
                        <mat-label>General Ledger Segment Code</mat-label>
                        <input matInput ngModel
                            [(ngModel)]="editProject.projectSegmentCode" 
                            id="projectSegmentCodeInput"
                            aria-label="Project Segment Code" 
                            #projectSegmentCode="ngModel"
                            name="projectSegmentCode">
                            <mat-hint>Optional</mat-hint>
                    </mat-form-field>
                </div>
            </mat-expansion-panel>
        <hr />
    </mat-card-content>

    <mat-card-actions *ngIf= "!loading">
        <button mat-flat-button (click)="closeDialog()" class="hds_button cancel" id="cancelButton">
            Cancel
        </button>
        <button mat-flat-button class="hds_button" (click)="onSubmit()"
            [disabled]="!editProjectForm.valid 
            || editProjectForm.pristine
            || (program.type == 'Public Housing' && !minTTPFormGroup.valid)
            || ((program.type == 'Public Housing' || program.type == 'Low Rent') && !ampProjectFormGroup.valid)" 
            id="Submit">
            Save Project
        </button>
    </mat-card-actions>
</form>

</mat-card>
    
